import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import clsx from 'clsx';

import lpdpTalenta from '../../../assets/img/lpdp-talenta.png';

import './style.css';

export interface MainLayoutProps {
  children: React.ReactNode;
  className?: string;
  showHeader?: boolean;
  showFooter?: boolean;
  headerProps?: any;
  footerProps?: any;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  className,
  showHeader = true,
  showFooter = true,
  headerProps = {
    logo: lpdpTalenta,
    // menuItems: [
    //   { label: 'Home', href: '#home' },
    //   { label: 'Features', href: '#features' },
    //   { label: 'About', href: '#about' },
    //   { label: 'Contact', href: '#contact' },
    // ],
    // ctaButton: {
    //   label: 'Get Started',
    //   href: '#contact',
    //   variant: 'primary'
    // }
  },
  footerProps = {}
}) => (
  <div className={clsx('main-layout', className)}>
    {showHeader && <Header logo={lpdpTalenta} {...headerProps} />}
    
    <main className="main-content">
        {children}
    </main>
    
    {showFooter && <Footer {...footerProps} />}
  </div>
);

export default MainLayout;